import Td from "./Td";
import { Draggable, Droppable } from "@hello-pangea/dnd";

const Tbody = ({
  tableData = [],
  isOrdering = true,
  tableActionDropdownContainer,
}) => {
  return (
    <Droppable droppableId="table-list" isDropDisabled={isOrdering}>
      {(provided) => (
        <tbody
          className="text-gable-green text-sm font-medium"
          {...provided.droppableProps}
          ref={provided.innerRef}
        >
          {tableData.map((item, index) => (
            <Draggable
              key={index}
              draggableId={`${item._id}${index}`}
              // key={index.toString()}
              // draggableId={index.toString()}
              index={index}
              isDragDisabled={isOrdering}
            >
              {(provided) => (
                <tr
                  className="border-b border-shades-04 last:border-b-0"
                  key={index}
                  ref={provided.innerRef}
                  {...provided.draggableProps}
                  {...provided.dragHandleProps}
                  onClick={() => {
                    item?.onClick && item?.onClick(item?._id);
                  }}
                >
                  {item.rowData.map((itemData, j) => (
                    <Td
                      key={`${itemData?._id}${j}`}
                      data={itemData}
                      align={itemData?.align}
                      actionDataDisabled={itemData.disabled || false}
                      actionData={itemData.actionData}
                      functions={itemData?.functions}
                      onClick={itemData?.onClick}
                      checkboxChecked={itemData.checked || false}
                      tableActionDropdownContainer={
                        tableActionDropdownContainer
                      }
                      onCheckboxChange={() =>
                        itemData.onCheckboxChange
                          ? itemData.onCheckboxChange(
                              itemData.itemDetails || {}
                            )
                          : () => {}
                      }
                    />
                  ))}
                </tr>
              )}
            </Draggable>
          ))}
          {provided.placeholder}
        </tbody>
      )}
    </Droppable>
  );
};

export default Tbody;
